import { Controller } from "@hotwired/stimulus"

// Binds "mousewheel", not the native "wheel". In this app "mousewheel" is synthesized by the
// jquery-mousewheel plugin bundled inside select2.full.js, which replays it straight into jQuery's
// own handler registry rather than through element.dispatchEvent - so a native addEventListener,
// and therefore a data-action, would never see it.
export default class extends Controller {
  connect() {
    // .side-panel and its two sibling mounts all set padding: 0, so clientHeight (content +
    // padding, no border) matches jQuery's former content-box .height() exactly.
    this.height = this.element.clientHeight;
    this.scrollHeight = this.element.scrollHeight;

    this.onWheel = this.onWheel.bind(this);
    $(this.element).on("mousewheel", this.onWheel);
  }

  disconnect() {
    $(this.element).off("mousewheel", this.onWheel);
  }

  onWheel(e) {
    const d = -e.originalEvent.deltaY;
    const el = this.element;
    if ((el.scrollTop === (this.scrollHeight - this.height) && d < 0) || (el.scrollTop === 0 && d > 0)) {
      e.preventDefault();
    }
  }
}
